import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormHeaderTabs } from "@lsq/nextgen/v2/form-header";

const LSQTabMenu = ({
  className,
  // optionClassName,
  options,
  onTabChange,
  activeIndex = 0,
  ...restProps
}) => {
  const tabs = options.map((option) => ({
    id: option.id || option.label,
    title: option.label,
    disabled: option.disabled || false,
  }));

  const [activeTab, setActiveTab] = useState(tabs[activeIndex]?.id || tabs[0]?.id);

  useEffect(() => {
    const newActiveId = tabs[activeIndex]?.id;
    if (newActiveId && newActiveId !== activeTab) {
      setActiveTab(newActiveId);
    }
  }, [activeIndex, tabs, activeTab]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    const index = tabs.findIndex(tab => tab.id === tabId);
    if (index !== -1 && onTabChange) {
      onTabChange({ index, value: options[index] });
    }
  };

  if (options?.length > 0)
    return (
      <FormHeaderTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        className={className}
        {...restProps}
      />
    );
};

LSQTabMenu.propTypes = {
  className: PropTypes.string,
  optionClassName: PropTypes.string,
  options: PropTypes.array.isRequired,
  onTabChange: PropTypes.func,
  activeIndex: PropTypes.number,
};

export default LSQTabMenu;
